import React from 'react';
import {
    Input,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Navbar,
    Nav,
    NavLink,
    Row,
    Col
} from 'reactstrap';
import ReactTable from "react-table";
import { connect } from "react-redux";
import NavBar from '../NavBar/navBar'
import {
    fetchFloor,
    saveFloor,
    deleteFloor,
} from '../../actions';
import Pagination from '../Pagination/pagination'
import { toast, ToastContainer } from 'react-toastify';
import { NavLink as RRNavLink } from 'react-router-dom';
import Tour from '../../Tour';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import "./addfloor.css";
import deleteIcon from '../../assets/delete.svg';
import radioButton from '../../assets/radioButton.svg';
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';

let errorDetails = ""

const initialState = {
    id: "",
    floorPlan: "",
    building: "",
    floor: "",
    floorId: "",
    floorName: "",
    isDeleteModalOpen: false,
    deleteID: "",
    isDisable: false,
    view: true,
    type: "direct",
    floorPlanName: "",
    image: [],
    floor_name: ""
}

class AddFloors extends React.Component {
    constructor(props) {
        super(props)
        this.saveData = this.saveData.bind(this)
        this.resetData = this.resetData.bind(this)
        this.validateData = this.validateData.bind(this)
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            ...initialState,
        }
    }

    floorColumns = [
        {
            Header: 'Building Name',
            accessor: 'building.building_name',
        },
        {
            Header: 'Floor Name',
            accessor: 'floor_name',
        },
        {
            Header: 'Floor ID',
            accessor: 'floor_id',
        },
        {
            Header: 'Floor Plan',
            accessor: 'floor_plan',
            Cell: (row) => (
                row.original.floor_plan
                    ? <a href="#floor" onClick={() => {
                        var image = new Image()
                        image.src = row.original.floor_plan[1]
                        this.handleImageClick(row.original.floor_plan, row.original.floor_name)
                    }}><img title={row.original.floor_plan[0]} src={row.original.floor_plan[1]} width="120" height="20" alt=""/></a>
                    : <span>-</span>
            ),
            className: "floor-plan-column"
        },
        {
            id: 'delete',
            accessor: str => "delete",
            Cell: (row) => (
                <div className='dropdown-filter'   onClick={(e) => this.handleButtonClick(e, row.original.id, row.original.floor_name)}>
                <img src={deleteIcon} alt=""/>
                </div>
            ),
            width: 80,
            className:"delete-button-padding"
        }
    ]

    handleButtonClick = (e, id, name) => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteName: name,
            deleteID: id
        }));
    }

    handleImageClick = (floor_plan,floor_name) => {
        this.setState(prevState => ({
                isImageModalOpen: !prevState.isImageModalOpen,
                image: floor_plan,
                floor_name: floor_name
         }))
    }

    componentDidMount() {
        this.props.fetchFloor()
    }

    onSelectBuilding = (event) => {
        const { value } = event.target
        this.setState({
            ...this.state,
            building: value,
        })
    }


    deleteFloor = () =>{
        this.props.deleteFloor(this.state.deleteID).then(response => {
            if(response.status === 204){
                if (appInsights && appInsights.trackEvent) {
                    appInsights.trackEvent({name: 'Floor Deleted',  properties: {id: this.state.deleteID}});
                }
                if (appInsights && appInsights.trackTrace) {
                    appInsights.trackTrace({message: 'Floor with ID '+ this.state.deleteID+' is deleted', severityLevel: SeverityLevel.Information});
                }
                toast.success(this.state.deleteName + " Deleted Successfully!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                if(parseInt(sessionStorage.getItem("floorId")) === this.state.deleteID) {
                        sessionStorage.setItem("building", "")
                        sessionStorage.setItem("buildingId", "")
                        sessionStorage.setItem("buildingName",  "")
                        sessionStorage.setItem("floorName", "")
                        sessionStorage.setItem("floorId", "")
                        sessionStorage.setItem("floor", "")
                }
                this.setState(prevState => ({
                    isDeleteModalOpen: false,
                    deleteName: "",
                    deleteID: ""
                }));
                this.props.fetchFloor()
            }
            else {
                if (appInsights && appInsights.trackTrace) {
                    appInsights.trackTrace({message: 'Floor couldn\'t be deleted!', properties: {id: this.state.deleteID}, severityLevel: SeverityLevel.Error});
                }
                toast.error(this.state.deleteName + " couldn't be deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) =>{
            let message = this.state.deleteName + " couldn't be deleted!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: 'Floor couldn\'t be deleted!', properties: {id: this.state.deleteID, error: error}, severityLevel: SeverityLevel.Error});
            }
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
        })
    }

    toggleDeleteModal = () => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteLocationId: ""
        }));
    }
    toggleImageModel = () => {
        this.setState(prevState => ({
            isImageModalOpen: !prevState.isImageModalOpen
        }))

    }

    handleChange(event) {
        if(event.target.name == ""){
            this.setState({
                ...this.state,
                ['addItem']: event.target.value
            })    
        }
        else{
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value
            })
        }
    };

    saveData = () => {
        if (this.validateData(this.state)) {
            let createData = {
                building :this.state.building,
                floor_id: this.state.floorId,
                floor_name: this.state.floorName,
                floor_plan: this.state.floorPlan,
                floor_plan_width: this.state.floor_plan_width
            }
            this.props.saveFloor(createData).then(response => {
                    this.resetData()
                    if (response.status === 201) {
                        if (appInsights && appInsights.trackEvent) {
                            appInsights.trackEvent({name: 'Floor Added', properties:{name: response.data.floor_name, id: response.data.floor_id}});
                        }
                        if (appInsights && appInsights.trackTrace) {
                            appInsights.trackTrace({message: 'Floor Added', properties:{name: response.data.floor_name, id: response.data.floor_id}, severityLevel: SeverityLevel.Information});
                        }
                        toast.success("Floor is added successfully to the list", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        this.props.fetchFloor()
                    }
                    else {
                        if (appInsights && appInsights.trackTrace) {
                            appInsights.trackTrace({message: 'Floor couldn\'t be added!', properties:{id: this.state.floorId, name: this.state.floorName}, severityLevel: SeverityLevel.Error});
                        }
                        let message = "Floor couldn't be added!"
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                })
                    .catch((error) => {
                        if (appInsights && appInsights.trackTrace) {
                            appInsights.trackTrace({message: 'Floor couldn\'t be added!', properties:{id: this.state.floorId, name: this.state.floorName, error: error}, severityLevel: SeverityLevel.Error});
                        }
                        let message = "Floor couldn't be added!"
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        })
                    })
        } 
        else {
            this.ErrorDetails()
        }    
    }

    ErrorDetails = () => {
        if (appInsights && appInsights.trackTrace) {
            appInsights.trackTrace({message: errorDetails, severityLevel: SeverityLevel.Verbose});
        }
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    resetData = () => {
        this.setState({floorId: "", floorName: "", building:"", floorPlanName:"", floorPlan: ""})
    } 

    cancelData = () => {
        this.setState(initialState)
    }

    validateData = (data) => {
        if (data.floorId.trim().length > 0 && data.floorName.trim().length > 0 && data.building && data.floorPlan) {
            return true
        }
        else if (!data.building) {
            errorDetails = "Select the Building from the drop down"
            return false
        }
        else if (!data.floorPlan) {
            errorDetails = "Uplaod a FloorPlan!"
            return false
        }
        else{
            errorDetails = "All *mandatory fields are required to create a Floor!"
            return false
        }
    }

    handleError = (err) => {
        console.error(err)
    }

    onChangeFile = event => {
        this.setState({
            floorPlan: event.target.files[0],
            floorPlanName:  event.target.files[0].name,
            image: URL.createObjectURL(event.target.files[0])
        })
    }

    onImageLoad = event => {
        let floor_width = 1268
        this.setState({
            floor_plan_width: floor_width<event.target.naturalWidth?floor_width:event.target.naturalWidth
        })
    }

    render() {
        return(
            <div className="manage-page page-layout" data-tut="reactour__manage">
                <NavBar />
                <div className={window.innerWidth>900?"dashboard-overview samples-page": "dashboard-overview-100 samples-page"}>
                    <div className="dashboard-content-25 ">
                        <Row form className="manage-page-header mt-0">
                            <Navbar className="navbar-results " light expand="md">
                                <Nav navbar>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt=''/>Manage Locations</span></NavLink>
                                    {/* <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/addLocations/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Map Locations</span></NavLink> */}
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/locations"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>View Locations</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/notifications/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Manage Notifications</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row>
                        <div className='sample-input-area'>
                            <Row form data-tut="reactour__dropdown">
                                <Col md={4} lg={2} xl={2}>
                                    <Input className="sample-input-fields" type="select" name="addItem" id="AddItem" value={this.state.addItem} onChange={this.handleChange} size="1">
                                        <option value="AddFloor" className="dashboard-options" default>Add a Floor</option>
                                        <option value="AddBuilding" className="dashboard-options" >Add a Building</option>
                                        <option value="AddRoom" className="dashboard-options" >Add a Room</option>
                                    </Input>   
                                </Col>
                                <Col md={4} lg={2} xl={2}>
                                    <Input className={this.state.building ? "sample-input-fields" : "sample-input-fields default-disabled"} type="select" name="building" id="Building" value={this.state.building} onChange={this.onSelectBuilding} size="1">
                                        <option value="" default disabled>Building</option>
                                        {this.props.buildingList.map((building, key) => {
                                            return <option className="dashboard-options" id={building.building_id} key={key} value={building.id}>{building.building_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col md={4} lg={2} xl={2}>
                                    <Input className={this.state.floorName ? "sample-input-fields" : "sample-input-fields default-disabled"} type="text" name="floorName" id="FloorName" value={this.state.floorName} onChange={this.handleChange} placeholder="Floor Name*" />
                                </Col>

                                <Col md={4} lg={2} xl={2}>
                                    <Input className={this.state.floorId ? "sample-input-fields" : "sample-input-fields default-disabled"} type="text" name="floorId" id="FloorId" size="10" value={this.state.floorId} onChange={this.handleChange} placeholder="Floor Id*" />
                                </Col>
                                <Col md={4} lg={3} xl={2}>
                                    <Input
                                        type="file"
                                        id="img"
                                        className={this.state.floorPlanName ? "upload-file sample-input-fields upload-input " : "upload-file sample-input-fields default-disabled upload-input"}
                                        accept='image/*'
                                        onChange={this.onChangeFile}
                                        value={this.state.floorPlan ? null : ""}
                                        data-title={this.state.floorPlanName || 'Upload Floorplan Image*'}
                                    />
                                    {this.state.floorPlan ? <img src={this.state.image} onLoad={this.onImageLoad} width="0" height="0" alt=''/> : null}
                                </Col>
                                <Col md={4} lg={12} xl={2}>
                                    <div className="manage-buttons d-flex justify-content-end">
                                        <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={() => this.resetData()} >Clear</Button>
                                        <Button id="applyFloorButton" type="submit" outline color="secondary" onClick={() => this.saveData()} >Add</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="grid-data" data-tut="reactour__tableFloor">
                        <div className="sample-list-header building-heading" >Floors</div>
                        {this.props.floors && this.props.floors.length > 0 ?
                            <div className="location-table-height">
                                <ReactTable className="Data-Table tables-height"
                                    data={this.props.floors}
                                    columns={this.floorColumns}
                                    showPagination={true}
                                    PaginationComponent={Pagination}
                                    defaultPageSize={10}
                                    minRows={0}
                                    sortable={false}
                                />
                            </div>
                            : <div className="no-data-msg"> No Floors Available</div>
                        }
                    </div>
                </div>
                <Modal isOpen={this.state.isDeleteModalOpen} toggle={this.toggleDeleteModal}>
                    <ModalHeader toggle={this.toggleDeleteModal} className="edit-popup delete-title">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                        Delete Floor
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        Are you sure you want to delete <i>{this.state.deleteName}</i> ?
                        <div className= "edit-popup-message"><span className="required-icon">Warning: </span>
                            This will also delete  Locations, Samples and Results in this Floor.</div>
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                        <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleDeleteModal}>No</Button>
                        <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteFloor}>Yes</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.isImageModalOpen} toggle={this.toggleImageModel}>
                    <ModalHeader toggle={this.toggleImageModel} className="edit-popup">{this.state.floor_name}</ModalHeader>
                    <ModalBody>
                        <img title={this.state.image[0]} src={this.state.image[1]} width="100%" alt=''/>
                    </ModalBody>
                </Modal>
                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                {this.state.addItem === "AddBuilding" ?
                    this.props.history.push("/manage/buildings/addBuildings")
                    :
                    this.state.addItem === "AddRoom" ?
                        this.props.history.push("/manage/buildings/addRooms")
                        : null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {
        buildingList: state.floor_data.buildingsList,
        floorsList:  state.floor_data.floorsList,
        floors: state.floor_data.floors,
        floorPagination: state.floor_data.floorPagination,
        floorParams: state.floor_data.floorParams,
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchFloor,
        saveFloor,
        deleteFloor
    }
)(AddFloors), 'Manage Floors', 'AddFloors');